import React from "react";

const Footer = (props) => {
  return (
    <footer className="studio-footer">
      {props.children}
      <p className="studio-footer__copy">
        <small>&copy; {new Date().getFullYear()} Liz Osborn</small>
      </p>
    </footer>
  );
};

export default Footer;
